import React from 'react'
import './index.scss'

const RecycleSuccessModal = ({ onClose }) => {
  return (
    <div className="gemstone-recycle-success">
      <div className="recycle-success-outer">
        <img
          className="recycle-success-title"
          src={require('@/assets/img/culturalExchange_gemstonerecycling/success@2x.png')}
          alt="回收成功"
        />
        <div className="recycle-success-text">
          后续奖励将在统一发放到G优账户，请在积分明细中查询。
        </div>
        <div className="recycle-success-btn" onClick={onClose}>我知道了</div>
      </div>
    </div>
  )
}

export default RecycleSuccessModal
